module.exports = __webpack_public_path__ + "img/flipkart (1) (1).1c6587a0.svg";